export default "__VITE_ASSET__DaaCn49___"